var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpClient } from "@/lib/http";
import { currentUser } from "@/core/users/session";
const ENDPOINTS_NORTH = {
    SEND_CHANGE_REQUEST: "/webapi/north-red/change-request",
    FETCH_PENDING_CHANGES: "/webapi/north-red/pending-changes",
    FETCH_SUPERVISOR_PENDING_CHANGES: "/webapi/north-red/supervisor-pending-changes",
    APPROVE_REJECT_CHANGE: "/webapi/north-red/update-status-requests",
};
const ENDPOINTS_CATALUNYA = {
    SEND_CHANGE_REQUEST: "/webapi/catalunya-red/change-request",
    FETCH_PENDING_CHANGES: "/webapi/catalunya-red/pending-changes",
    FETCH_SUPERVISOR_PENDING_CHANGES: "/webapi/catalunya-red/supervisor-pending-changes",
    APPROVE_REJECT_CHANGE: "/webapi/catalunya-red/update-status-requests",
};
const ENDPOINTS_CATALUNYA_RPV = {
    SEND_CHANGE_REQUEST: "/webapi/catalunya-rpv-red/change-request",
    FETCH_PENDING_CHANGES: "/webapi/catalunya-rpv-red/pending-changes",
    FETCH_SUPERVISOR_PENDING_CHANGES: "/webapi/catalunya-rpv-red/supervisor-pending-changes",
    APPROVE_REJECT_CHANGE: "/webapi/catalunya-rpv-red/update-status-requests",
};
const ENDPOINTS_LEVANTE = {
    SEND_CHANGE_REQUEST: "/webapi/levante-objetivos/change-request",
    FETCH_PENDING_CHANGES: "/webapi/levante-objetivos/pending-changes",
    FETCH_SUPERVISOR_PENDING_CHANGES: "/webapi/levante-objetivos/supervisor-pending-changes",
    APPROVE_REJECT_CHANGE: "/webapi/levante-objetivos/update-status-requests",
};
function getEndpoints(table) {
    if (isCatalunyaData()) {
        if (table === 'catalunya_rpv') {
            return ENDPOINTS_CATALUNYA_RPV;
        }
        else {
            return ENDPOINTS_CATALUNYA;
        }
    }
    else if (isLevanteData()) {
        return ENDPOINTS_LEVANTE;
    }
    else {
        return ENDPOINTS_NORTH;
    }
}
// Helper para detectar si es Norte
function isNorthData() {
    return currentUser().area_code === "N";
}
// Helper para detectar si es Catalunya
function isCatalunyaData() {
    const catalunya_region_codes = ["E100"];
    return catalunya_region_codes.includes(currentUser().region_code);
}
function isLevanteData() {
    const levante_region_codes = ["E300"];
    return levante_region_codes.includes(currentUser().region_code);
}
function isRedRevisada() {
    return isNorthData() || isCatalunyaData();
}
function isNumObjetivos() {
    return isLevanteData();
}
export const sendChangeRequest = (changeRequest, table) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    // Make API call
    let response = yield HttpClient.post(getEndpoints(table).SEND_CHANGE_REQUEST, changeRequest);
    if ("errors" in response) {
        console.warn("Bulk edit failed:", response.message);
        response = {
            errors: response.errors,
            message: response.message,
        };
    }
    // Handle errors
    return {
        success: "failed" in response ? response.failed === 0 : true,
        message: response.message || "Cambios aplicados correctamente",
        errors: ((_a = response.errors) !== null && _a !== void 0 ? _a : []).map(({ error }) => error),
    };
});
export const fetchPendingChanges = (_a) => __awaiter(void 0, [_a], void 0, function* ({ period, table, supervisor = false }) {
    const endpoints = getEndpoints(table);
    const url = supervisor ? endpoints.FETCH_SUPERVISOR_PENDING_CHANGES : endpoints.FETCH_PENDING_CHANGES;
    const response = yield HttpClient.get(url + '?status=pending');
    const data = response.data.filter((item) => item.ano_natural === period.year && item.mes_natural === period.month);
    //sort data by created_at newest first
    data.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    const ChangeRequestsMap = {};
    data.forEach((item) => {
        let changeRequestId;
        if (isLevanteData()) {
            changeRequestId = `${item.delegacion_zona_de_ventas}-num_objetivos_conseguidos-${item.ano_natural}-${item.mes_natural}`;
        }
        else if (isNorthData()) {
            changeRequestId = `${item.delegacion}-${item.sala}-red_revisada-${item.ano_natural}-${item.mes_natural}`;
        }
        else {
            changeRequestId = `${item.distribuidor}-red_revisada-${item.ano_natural}-${item.mes_natural}`;
        }
        if (!ChangeRequestsMap[changeRequestId]) {
            ChangeRequestsMap[changeRequestId] = {
                id: changeRequestId,
                delegacion: item.delegacion,
                sala: item.sala,
                distribuidor: item.distribuidor,
                delegacion_zona_de_ventas: item.delegacion_zona_de_ventas,
                objective_type: item.objective_type,
                mes_natural: item.mes_natural,
                ano_natural: item.ano_natural,
                // red_revisada_ant: item.red_revisada_ant,
                // red_revisada: item.red_revisada,
                fields: {},
                changeIds: [],
            };
            if (isNumObjetivos()) {
                ChangeRequestsMap[changeRequestId]['num_objetivos_conseguidos_ant'] = item.num_objetivos_conseguidos_ant;
                ChangeRequestsMap[changeRequestId]['num_objetivos_conseguidos'] = item.num_objetivos_conseguidos;
            }
            else {
                ChangeRequestsMap[changeRequestId]['red_revisada_ant'] = item.red_revisada_ant;
                ChangeRequestsMap[changeRequestId]['red_revisada'] = item.red_revisada;
            }
        }
        const changeRequest = ChangeRequestsMap[changeRequestId];
        // Add the field change to the row
        if (isNumObjetivos()) {
            changeRequest.fields['Nº Objvos Conseg. REV'] = {
                num_objetivos_conseguidos_ant: item.num_objetivos_conseguidos_ant,
                num_objetivos_conseguidos: item.num_objetivos_conseguidos,
            };
        }
        if (isRedRevisada()) {
            changeRequest.fields[item.objective_type] = {
                red_revisada_ant: item.red_revisada_ant,
                red_revisada: item.red_revisada,
            };
        }
        // Track change IDs
        changeRequest.changeIds.push(item.id);
    });
    return Object.values(ChangeRequestsMap);
});
/**
 * Fetch pending changes formatted for table display
 * Returns array of partial rows with changed field values
 */
export const fetchPendingChangesForTable = (dataRows_1, table_1, ...args_1) => __awaiter(void 0, [dataRows_1, table_1, ...args_1], void 0, function* (dataRows, table, supervisor = false) {
    const endpoints = getEndpoints(table);
    const url = supervisor ? endpoints.FETCH_SUPERVISOR_PENDING_CHANGES : endpoints.FETCH_PENDING_CHANGES;
    const response = yield HttpClient.get(url + '?status=pending');
    const selectedPeriod = dataRows === null || dataRows === void 0 ? void 0 : dataRows.period;
    const changes = response.data.filter((change) => {
        if (!selectedPeriod) {
            return true;
        }
        return change.ano_natural === selectedPeriod.year && change.mes_natural === selectedPeriod.month;
    });
    // Group changes by row identifier
    const changesByRowKey = new Map();
    for (const change of changes) {
        // Create row key for matching
        let rowKey;
        if (isNorthData()) {
            rowKey = `${change.delegacion}|${change.sala}|${change.ano_natural}|${change.mes_natural}`;
        }
        else if (isLevanteData()) {
            let periodo = 0;
            if ([1, 2, 3].includes(change.mes_natural))
                periodo = 1;
            else if ([4, 5, 6].includes(change.mes_natural))
                periodo = 2;
            else if ([7, 8, 9].includes(change.mes_natural))
                periodo = 3;
            else if ([10, 11, 12].includes(change.mes_natural))
                periodo = 4;
            rowKey = `${change.delegacion_zona_de_ventas}|${change.ano_natural}|${periodo}`;
        }
        else {
            rowKey = `${change.distribuidor}|${change.ano_natural}|${change.mes_natural}`;
        }
        // Get or create the pending change row
        if (!changesByRowKey.has(rowKey)) {
            changesByRowKey.set(rowKey, {
                _row_id: {
                    delegacion: change.delegacion,
                    sala: change.sala,
                    distribuidor: change.distribuidor,
                    delegacion_zona_de_ventas: change.delegacion_zona_de_ventas,
                    ano_natural: change.ano_natural,
                    mes_natural: change.mes_natural,
                },
            });
        }
        const pendingRow = changesByRowKey.get(rowKey);
        // Build the field key (no mapping needed - API keys match table field keys)
        if (isNumObjetivos()) {
            const fieldKey = `periods.${change.mes_natural.toString().padStart(2, '0')}.objetivos_conseguidos_rev_rows`;
            pendingRow[fieldKey] = change.num_objetivos_conseguidos;
        }
        if (isRedRevisada()) {
            const fieldKey = `${change.objective_type}.red_revisada`;
            pendingRow[fieldKey] = change.red_revisada;
        }
    }
    return Array.from(changesByRowKey.values());
});
export const approveRejectChange = (resolution, table) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    const requestsPayload = {
        ids: resolution.changeRequest.changeIds,
        status: resolution.status,
        comment: resolution.comment,
    };
    // Make API call to approve/reject changes
    const response = yield HttpClient.post(getEndpoints(table).APPROVE_REJECT_CHANGE, requestsPayload);
    return {
        success: response.status && response.status === 'success',
        message: (_d = (_c = (_b = (_a = response.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.error) !== null && _c !== void 0 ? _c : response.message) !== null && _d !== void 0 ? _d : "Change request processed successfully.",
    };
});
